import { getLocationStorage } from 'utilities/window.js';

const PREFIX = 'metservice:';
/** The data is saved per domain, it means that only pages with the same domain can access and modify it.  */
export const getLocalStorageItem = <T>(key: string): T | undefined => {
  try {
    const k = `${PREFIX}${key}`;
    const item = getLocationStorage()?.getItem(k);

    if (!item) {
      // No item found under that key
      return undefined;
    }

    return JSON.parse(item) as T;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

/** Puts Item In Local Storage */
export const setLocalStorageItem = (key: string, data?: unknown): boolean => {
  if (data === null || data === undefined) {
    return false;
  }

  if (Array.isArray(data) && data.length === 0) {
    return false;
  }

  if (data.constructor === Object && Object.keys(data).length === 0) {
    return false;
  }

  try {
    const k = `${PREFIX}${key}`;
    const json = JSON.stringify(data);
    getLocationStorage()?.setItem(k, json);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
